import React, { FunctionComponent } from 'react';
import { Modal, ModalHeader, ModalFooter, ModalContent, ModalFooterButtons } from 'ui/molecules/modal';
import Translate from 'ui/atoms/translate';
import Hint from 'src/ui/atoms/hint';

export interface DeleteGroupUserSuccessModalProps {
  onClose: () => void;
  group?: string;
}

const DeleteGroupUserSuccessModal: FunctionComponent<DeleteGroupUserSuccessModalProps> = (props) => {
  const { onClose } = props;

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="successDeleteGroupUserModal.title" />
      </ModalHeader>
      <ModalContent>
        <Hint variant="success">
          <Translate name="successDeleteGroupUserModal.hint" />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.close" />,
              onClick: onClose,
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteGroupUserSuccessModal;
